//Principais
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgSelectConfig } from "@ng-select/ng-select";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";

//Métodos
import { AtividadePsicologoDeslocamento } from 'src/app/shared/models/atividade-psicologo/atividade-psicologo-deslocamento';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';
import { Polo } from "src/app/shared/models/polo/Polo";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";

//Serviços
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { ConvivaErrorHandlingService } from "src/app/shared/services/convivaErrorHandlingService";
import { EscolaService } from "src/app/shared/services/escola.service";
import { MapsService } from 'src/app/shared/services/maps.service';
import { PsicologoService } from "src/app/shared/services/psicologo.service";
import { UtilsService } from 'src/app/shared/services/utils.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';

import { Perfil } from "src/app/shared/enums/Perfis/Perfis";

@Component({
    selector: 'app-deslocamento',
    templateUrl: './psicologo-deslocamento.component.html',
    styleUrls: ['./psicologo-deslocamento.component.scss'],
    standalone: true,
    providers:[NgSelectConfig,EscolaService,NgxSpinnerService,ToastrService,ConvivaErrorHandlingService,AuthService,PsicologoService,UtilsService,MapsService],
    imports:[libsCommonImports,angularCommonImports]
})

export class PageDeslocamentoPsicologoComponent implements OnInit {

  @Output() proximoPasso = new  EventEmitter<AtividadePsicologoDeslocamento>();
  @Input({ required: false }) dadosDeslocamento: AtividadePsicologoDeslocamento | null;

  // Variaveis de Login
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  constructor(
    private config: NgSelectConfig,
    private escolaService: EscolaService,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private authService: AuthService,
    private psicologoService:PsicologoService,
    private utilsService: UtilsService,
    private mapsService:MapsService
  ) {
    this.config.notFoundText = 'Não encontrado';

    // Dados usuário logado
    this.userLogado = this.authService.getUser();

    if(this.userLogado != null && !this.userLogado.flPsicologo){
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  // Variaveis de Mapa
  public requestRoute: google.maps.DirectionsRequest  = <google.maps.DirectionsRequest>{};
  public resultRoute: google.maps.DirectionsResult = <google.maps.DirectionsResult>{};
  public totalKm: number = 0;
  public totalSeg: number = 0;
  public totalDuration: string;
  public horaChegada: string;
  public lstTipoTransporte = [{id: 1, name:"Bicicleta" }, {id: 2, name:"Carro" }, {id: 3, name:"Transporte público" }, {id: 4, name:"A Pé" }, {id: 5, name:"Motocicleta" }];
  public latOrigem: number  = 0;
  public lngOrigem: number = 0;
  public latDestino: number = 0;
  public lngDestino: number = 0;

  // Combos de Origem
  public polosOrigem: Polo[] = [];
  public diretoriasOrigem: Diretoria[] = [];
  public escolasOrigem: Escola[] = [];

  // Combos de Destino
  public polosDestino: Polo[] = [];
  public diretoriasDestino: Diretoria[] = [];
  public escolasDestino: Escola[] = [];

  // Variaveis de Deslocamento Escola/Diretoria
  public escolaOrigem: Escola = new Escola();
  public escolaDestino: Escola = new Escola();
  public diretoriaOrigem: Diretoria = new Diretoria();
  public diretoriaDestino: Diretoria = new Diretoria();
  public titleOrigem: string = '';
  public titleOrigemMark: string = '';
  public titleDestino: string = '';
  public titleDestinoMark: string = '';

  // Me fala como vai ser o deslocamento
  public atividadeDiretoriaOrigem: boolean = false;
  public atividadeDiretoriaDestino: boolean = false;

  // Forms
  public formDeslocamento!: FormGroup;
  public get form() { return this.formDeslocamento.controls; }
  public submitted: boolean;
  public gerouRota: boolean = false;
  public msgLatLongInvalida: string = '';
  public model: AtividadePsicologoDeslocamento = new AtividadePsicologoDeslocamento();

  public async ngOnInit() {

    // Form Deslocamento
    this.formDeslocamento = new FormGroup({
      codigoPoloOrigem: new FormControl(null, [Validators.required]),
      codigoDiretoriaOrigem: new FormControl(null, [Validators.required]),
      codigoEscolaOrigem: new FormControl(null, [Validators.required]),

      codigoPoloDestino: new FormControl(null, [Validators.required]),
      codigoDiretoriaDestino: new FormControl(null, [Validators.required]),
      codigoEscolaDestino: new FormControl(null, [Validators.required]),

      horarioSaida: new FormControl(null, [Validators.required]),
      codigoTipoTransporte: new FormControl(null, [Validators.required]),
      horarioChegada: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
      tempoDeslocamento: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
      kmPercorrido: new FormControl({value: null, disabled: true}, this.gerouRota ? [Validators.required] : null),
    });

    if (this.userLogado?.codigoPerfil === Perfil.CoordenadorPsicologo) {
      await this.getPolosPerfilCoordenador();
    } else if (this.userLogado?.flPsicologo) {
      await this.getPoloDiretoriaPsicologo();
    } else {
        if( this.atribuicoesLogin.NumeroComportamento == 1) {
          await this.getPolosAdmin();
        }
        if(this.atribuicoesLogin.NumeroComportamento == 2) {
          await this.getPolosPerfilDiretor();
        }
        if(this.atribuicoesLogin.NumeroComportamento == 3 || this.atribuicoesLogin.NumeroComportamento == 4) {
          await this.getPolosPerfilProfessor();
        }
    }

    if(this.dadosDeslocamento)
      await this.setDadosDeslocamento();
  }

  public async setDadosDeslocamento(){
    if(this.dadosDeslocamento) {
      this.form.codigoPoloOrigem?.setValue(this.dadosDeslocamento.codigoPoloOrigem);
      this.form.codigoDiretoriaOrigem?.setValue(this.dadosDeslocamento.codigoDiretoriaOrigem);
      this.form.codigoEscolaOrigem?.setValue(this.dadosDeslocamento.codigoEscolaOrigem);

      this.form.codigoPoloDestino?.setValue(this.dadosDeslocamento.codigoPoloDestino);
      await this.getDiretoriasPorPoloDestino();
      this.form.codigoDiretoriaDestino?.setValue(this.dadosDeslocamento.codigoDiretoriaDestino);
      await this.trocaDiretoriaDestino();
      this.form.codigoEscolaDestino?.setValue(this.dadosDeslocamento.codigoEscolaDestino);

      this.form.codigoTipoTransporte?.setValue(this.dadosDeslocamento.codigoTipoTransporte);
      this.form.horarioSaida?.setValue(this.dadosDeslocamento.horarioSaida);
      this.form.horarioChegada?.setValue(this.dadosDeslocamento.horarioChegada);
      this.form.tempoDeslocamento?.setValue(this.dadosDeslocamento.tempoDeslocamento);
      this.form.kmPercorrido?.setValue(this.dadosDeslocamento.kmPercorrido);

      await this.gerarRota();
    }
  }

  //#region Polos

  public async getPoloDiretoriaPsicologo(){
    const response = await lastValueFrom(this.psicologoService.getPoloPsicologo(this.userLogado!.cpf))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polosOrigem = [response.data];
    this.polosDestino = [response.data];

    this.formDeslocamento.get('codigoPoloOrigem')?.setValue(this.polosOrigem[0].codigoPolo);
    this.form.codigoPoloOrigem.disable();

    this.formDeslocamento.get('codigoPoloDestino')?.setValue(this.polosDestino[0].codigoPolo);
    this.form.codigoPoloDestino.disable();

    await this.getDiretoriasPorPoloOrigem();
    await this.getEscolasPorDiretoriaOrigem();

    await this.getDiretoriasPorPoloDestino();
  }

  /** Coordenador: polos de todas as UREs do login; destino editável quando houver mais de um polo. */
  public async getPolosPerfilCoordenador() {
    this.spinnerService.show();

    const codigosDiretoria = this.getCodigosDiretoriaUsuario();
    const parametroPolos =
      codigosDiretoria.length > 0
        ? codigosDiretoria
        : this.userLogado?.DadosUsuario?.[0]?.CodigoDiretoria;

    const response = await lastValueFrom(this.psicologoService.getPolos(parametroPolos))
      .catch((err) => this.ConvivaErrors.handleResultError(err));

    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    const todosPolos: Polo[] = response.data ?? [];
    const poloSessao = this.resolverPoloSessaoCoordenador(todosPolos);

    this.polosDestino = todosPolos;
    this.polosOrigem =
      poloSessao > 0
        ? todosPolos.filter((p) => p.codigoPolo === poloSessao)
        : todosPolos.length
          ? [todosPolos[0]]
          : [];

    if (!this.polosOrigem.length) {
      this.polosOrigem = [...todosPolos];
    }

    const poloOrigem = poloSessao || this.polosOrigem[0]?.codigoPolo;
    const poloDestinoInicial = poloOrigem || this.polosDestino[0]?.codigoPolo;

    this.form.codigoPoloOrigem.setValue(poloOrigem);
    this.form.codigoPoloDestino.setValue(poloDestinoInicial);
    this.form.codigoPoloOrigem.disable();

    if (this.userLogado && poloOrigem) {
      this.userLogado.codigoPolo = poloOrigem;
      this.authService.setUser(this.userLogado);
    }

    if (this.polosDestino.length > 1) {
      this.form.codigoPoloDestino.enable();
    } else {
      this.form.codigoPoloDestino.disable();
    }

    await this.getDiretoriasPorPoloOrigem();
    this.aplicarDiretoriaEscolaOrigemSessao();
    await this.getEscolasPorDiretoriaOrigem();
    await this.getDiretoriasPorPoloDestino();

    this.spinnerService.hide();
  }

  private getCodigosDiretoriaUsuario(): number[] {
    return [
      ...new Set(
        (this.userLogado?.DadosUsuario ?? [])
          .map((u) => u.CodigoDiretoria)
          .filter((c): c is number => typeof c === 'number' && c > 0),
      ),
    ];
  }

  private resolverPoloSessaoCoordenador(todosPolos: Polo[]): number {
    if (this.userLogado?.codigoPolo && todosPolos.some((p) => p.codigoPolo === this.userLogado!.codigoPolo)) {
      return this.userLogado.codigoPolo;
    }

    const diretoriaSessao = this.userLogado?.codigoDiretoria;
    if (diretoriaSessao) {
      const poloAtribuicao = this.userLogado?.DadosUsuario?.find(
        (u) => u.CodigoDiretoria === diretoriaSessao,
      )?.CodigoPolo;
      if (poloAtribuicao && todosPolos.some((p) => p.codigoPolo === poloAtribuicao)) {
        return poloAtribuicao;
      }
    }

    return todosPolos[0]?.codigoPolo ?? 0;
  }

  private aplicarDiretoriaEscolaOrigemSessao(): void {
    const codDiretoria =
      this.userLogado?.codigoDiretoria && this.userLogado.codigoDiretoria > 0
        ? this.userLogado.codigoDiretoria
        : null;

    if (!codDiretoria) {
      return;
    }

    const existeNaLista = this.diretoriasOrigem.some((d) => d.codigoDiretoria === codDiretoria);
    if (!existeNaLista) {
      const atribuicao = this.userLogado?.DadosUsuario?.find((u) => u.CodigoDiretoria === codDiretoria);
      const diretoria = new Diretoria();
      diretoria.codigoDiretoria = codDiretoria;
      diretoria.nomeDiretoria = atribuicao?.NomeDiretoria ?? '';
      this.diretoriasOrigem.push(diretoria);
      this.diretoriasOrigem.sort((a, b) =>
        (a.nomeDiretoria ?? '').localeCompare(b.nomeDiretoria ?? '', 'pt-BR'),
      );
    }

    this.form.codigoDiretoriaOrigem.setValue(codDiretoria);
    this.form.codigoDiretoriaOrigem.enable();
  }

  public async getPolosAdmin() {
    this.spinnerService.show();

    const  response = await lastValueFrom(this.psicologoService.getPolos())
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polosOrigem = response.data;
    this.polosDestino = response.data;

    this.spinnerService.hide();

    if(this.userLogado?.codigoPolo && this.userLogado?.codigoPolo > 0)
      await this.ativaPolo();

    this.spinnerService.hide();
  }

  public async getPolosPerfilDiretor(){
    this.spinnerService.show();

    const codigosDiretoriaUsuario = [
      ...new Set(
        (this.userLogado?.DadosUsuario ?? [])
          .map((u) => u.CodigoDiretoria)
          .filter((c): c is number => typeof c === 'number' && c > 0),
      ),
    ];
    const parametroPolos =
      codigosDiretoriaUsuario.length > 0
        ? codigosDiretoriaUsuario
        : this.userLogado?.DadosUsuario?.[0]?.CodigoDiretoria;

    const response = await lastValueFrom(this.psicologoService.getPolos(parametroPolos))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polosOrigem = response.data;
    this.polosDestino = response.data;

    const codigosPolosResposta = new Set(this.polosOrigem.map((p) => p.codigoPolo));
    const poloPreferido =
      this.userLogado?.codigoPolo && codigosPolosResposta.has(this.userLogado.codigoPolo)
        ? this.userLogado.codigoPolo
        : this.polosOrigem[0]?.codigoPolo;

    this.form.codigoPoloOrigem.setValue(poloPreferido);
    this.form.codigoPoloDestino.setValue(poloPreferido);

    if (this.userLogado && poloPreferido) {
      this.userLogado.codigoPolo = poloPreferido;
      this.authService.setUser(this.userLogado);
    }

    if (this.polosDestino.length > 1) {
      this.form.codigoPoloOrigem.enable();
      this.form.codigoPoloDestino.enable();
    } else {
      this.form.codigoPoloOrigem.disable();
      this.form.codigoPoloDestino.disable();
    }

    if(this.userLogado?.DadosUsuario?.[0]?.CodigoDiretoria && this.userLogado.DadosUsuario[0].CodigoDiretoria > 0){
      await this.getDiretoriasPorPoloOrigem();
      await this.getEscolasPorDiretoriaOrigem();
      await this.getDiretoriasPorPoloDestino();
    }

    this.spinnerService.hide();
  }

  public async getPolosPerfilProfessor(){
    this.spinnerService.show();
    const response = await lastValueFrom(this.psicologoService.getPolos(this.userLogado?.DadosUsuario[0].CodigoDiretoria))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.polosOrigem = response.data;
    this.form.codigoPoloOrigem.setValue(this.polosOrigem[0].codigoPolo);
    this.form.codigoPoloOrigem.disable();

    if(this.atribuicoesLogin?.CodigoDiretoria && this.atribuicoesLogin?.CodigoDiretoria > 0 && this.atribuicoesLogin?.CodigoEscola && this.atribuicoesLogin?.CodigoEscola > 0) {

      this.userLogado?.DadosUsuario.forEach(item => {
        const diretoria = new Diretoria();
        diretoria.codigoDiretoria = item.CodigoDiretoria;
        diretoria.nomeDiretoria = item.NomeDiretoria;
        this.diretoriasOrigem = [diretoria];

        const escola = new Escola();
        escola.codigoEscola = item.CodigoEscola;
        escola.nomeEscola = item.NomeEscola;
        this.escolasOrigem = [escola];
      });

      this.form.codigoDiretoriaOrigem.setValue(this.userLogado?.DadosUsuario[0].CodigoDiretoria);
      this.form.codigoEscolaOrigem.setValue(this.userLogado?.DadosUsuario[0].CodigoEscola);
    }

    this.spinnerService.hide();
  }

  public async ativaPolo(){
    if(this.userLogado?.codigoPolo)
      this.formDeslocamento.get('codigoPoloOrigem')?.setValue(this.userLogado?.codigoPolo);

    if(this.userLogado)
      this.authService.setUser(this.userLogado);

    await this.getDiretoriasPorPoloOrigem();
    await this.getEscolasPorDiretoriaOrigem();
  }

  public async cambioPoloOrigem()
  {
    const codigoPO = this.formDeslocamento.get('codigoPoloOrigem')?.value;
    if(this.userLogado)
    {
      this.userLogado.codigoPolo = codigoPO == null ? 0 : codigoPO;
      this.authService.setUser(this.userLogado);
    }

    this.form.codigoDiretoriaOrigem.enable();
    this.form.codigoEscolaOrigem.enable();
    this.zerarEscolaOrigem();

    await this.getDiretoriasPorPoloOrigem();
    await this.removerRota();
  }

  public async cambioPoloDestino()
  {
    const codigoPO = this.formDeslocamento.get('codigoPoloDestino')?.value;
    if(codigoPO && codigoPO > 0){
      this.form.codigoDiretoriaDestino.enable();
      this.form.codigoEscolaDestino.enable();
      this.zerarEscolaDestino();

      await this.getDiretoriasPorPoloDestino();
      await this.removerRota();
    }
  }

  //#endregion

  //#region Diretoria Origem

  public async getDiretoriasPorPoloOrigem() {
    const codigoPoloOrigem =
      this.formDeslocamento?.get('codigoPoloOrigem')?.value ?? this.userLogado?.codigoPolo;

    if (codigoPoloOrigem && codigoPoloOrigem > 0 && this.userLogado) {
      this.userLogado.codigoPolo = codigoPoloOrigem;
      this.authService.setUser(this.userLogado);
    }

    if(codigoPoloOrigem && codigoPoloOrigem > 0){

      this.zerarDiretoriaOrigem();
      this.spinnerService.show();

      const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPoloOrigem))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

      if(!response.isSucess){
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.diretoriasOrigem = response.data;
      this.mesclarDiretoriasOrigemComPerfilUsuario(codigoPoloOrigem);
      this.form.codigoDiretoriaOrigem.enable();
      this.ativaDiretoriaOrigem();
      this.aplicarDiretoriaEscolaOrigemSessao();
      this.spinnerService.hide();
    }

    if(this.userLogado) {
      this.userLogado.codigoDiretoria = this.userLogado.codigoDiretoria == null ? 0 : this.userLogado.codigoDiretoria ;
      this.authService.setUser(this.userLogado);
    }
  }

  private mesclarDiretoriasOrigemComPerfilUsuario(codigoPoloOrigem: number): void {
    const codigos = new Set(this.diretoriasOrigem.map((d) => d.codigoDiretoria));
    const incluir = (cod: number | null | undefined, nome: string | null | undefined) => {
      if (!cod || cod <= 0 || codigos.has(cod)) {
        return;
      }
      const d = new Diretoria();
      d.codigoDiretoria = cod;
      d.nomeDiretoria = nome ?? '';
      this.diretoriasOrigem.push(d);
      codigos.add(cod);
    };

    this.userLogado?.DadosUsuario?.forEach((u) => {
      if (u.CodigoPolo && u.CodigoPolo > 0 && u.CodigoPolo !== codigoPoloOrigem) {
        return;
      }
      incluir(u.CodigoDiretoria, u.NomeDiretoria);
    });

    this.diretoriasOrigem.sort((a, b) =>
      (a.nomeDiretoria ?? '').localeCompare(b.nomeDiretoria ?? '', 'pt-BR'),
    );
  }

  public ativaDiretoriaOrigem(){
    if(this.diretoriasOrigem && this.userLogado?.codigoDiretoria != 0) {

      const diretoria = this.diretoriasOrigem.find(s => s.codigoDiretoria == this.userLogado?.codigoDiretoria);
      if(this.userLogado?.codigoDiretoria != undefined  && diretoria){
        this.formDeslocamento.get('codigoDiretoriaOrigem')?.setValue(this.userLogado?.codigoDiretoria);
      }
    }

    if(this.userLogado)
        this.authService.setUser(this.userLogado);
  }

  public zerarDiretoriaOrigem() {
    this.diretoriasOrigem = [];
    this.formDeslocamento.get('codigoDiretoriaOrigem')?.patchValue(null);
  }

  //#endregion

  //#region Diretoria Destino

  /**
   * Garante no destino as UREs do vínculo do usuário com o polo e a URE de origem atual
   * (deslocamentos internos / lacunas na tabela polo–diretoria).
   */
  private mesclarDiretoriasDestinoComPerfilUsuario(codigoPoloDestino: number): void {
    const codigos = new Set(this.diretoriasDestino.map((d) => d.codigoDiretoria));
    const incluir = (cod: number | null | undefined, nome: string | null | undefined) => {
      if (!cod || cod <= 0 || codigos.has(cod)) {
        return;
      }
      const d = new Diretoria();
      d.codigoDiretoria = cod;
      d.nomeDiretoria = nome ?? '';
      this.diretoriasDestino.push(d);
      codigos.add(cod);
    };

    this.userLogado?.DadosUsuario?.forEach((u) => {
      if (u.CodigoPolo && u.CodigoPolo > 0 && u.CodigoPolo !== codigoPoloDestino) {
        return;
      }
      incluir(u.CodigoDiretoria, u.NomeDiretoria);
    });

    const codOrigem =
      (this.formDeslocamento.get('codigoDiretoriaOrigem')?.value as number | null) ??
      (this.userLogado?.codigoDiretoria && this.userLogado.codigoDiretoria > 0
        ? this.userLogado.codigoDiretoria
        : null);

    if (codOrigem) {
      const nomeOrigem =
        this.diretoriasOrigem.find((o) => o.codigoDiretoria === codOrigem)?.nomeDiretoria ??
        this.userLogado?.DadosUsuario?.find((u) => u.CodigoDiretoria === codOrigem)?.NomeDiretoria;
      incluir(codOrigem, nomeOrigem);
    }

    this.diretoriasDestino.sort((a, b) =>
      (a.nomeDiretoria ?? '').localeCompare(b.nomeDiretoria ?? '', 'pt-BR'),
    );
  }

  public async getDiretoriasPorPoloDestino() {
    const codigoPO = this.formDeslocamento.get('codigoPoloDestino')?.value;
    if(codigoPO && codigoPO > 0){

      this.zerarDiretoriaDestino();
      this.spinnerService.show();

      const response = await lastValueFrom(this.psicologoService.getDiretoriaPorPolo(codigoPO))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

      if(!response.isSucess){
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.diretoriasDestino = response.data;
      this.mesclarDiretoriasDestinoComPerfilUsuario(codigoPO);
      this.form.codigoDiretoriaDestino.enable();
      this.spinnerService.hide();
    }
  }

  public zerarDiretoriaDestino() {
    this.diretoriasDestino = [];
    this.formDeslocamento.get('codigoDiretoriaDestino')?.patchValue(null);
  }

  //#endregion

  //#region Diretorias/Escolas Origem

  public async trocaDiretoriaOrigem(){
    const codigoDiretoria = this.formDeslocamento.get('codigoDiretoriaOrigem')?.value;

    if(this.userLogado && codigoDiretoria)
    {
      this.userLogado.codigoDiretoria = codigoDiretoria == null ? 0 : codigoDiretoria;
      this.authService.setUser(this.userLogado);
    }

    if(codigoDiretoria && codigoDiretoria > 0)
      await this.getEscolasPorDiretoriaOrigem();
    else{
      this.escolasOrigem = [];
      this.form.codigoEscolaOrigem.setValue(null);
    }

    this.ValidaAtividadeDiretoriaOrigem();
    await this.removerRota();

    const codPoloDest = this.formDeslocamento.get('codigoPoloDestino')?.value;
    if (codPoloDest && codPoloDest > 0 && this.diretoriasDestino.length > 0) {
      this.mesclarDiretoriasDestinoComPerfilUsuario(codPoloDest);
    }
  }

  public async getEscolasPorDiretoriaOrigem(){
    const codigoDiretoria =
      (this.formDeslocamento.get('codigoDiretoriaOrigem')?.value as number | null) ??
      this.userLogado?.codigoDiretoria;

    if(this.userLogado && codigoDiretoria) {
      this.userLogado.codigoDiretoria = codigoDiretoria;
      this.userLogado.codigoEscola = this.userLogado.codigoEscola == null ? 0 : this.userLogado.codigoEscola;
      this.authService.setUser(this.userLogado);
    }

    if(codigoDiretoria && codigoDiretoria > 0) {
      this.spinnerService.show();
      this.zerarEscolaOrigem();

      const response = await lastValueFrom( this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

        if(!response.isSucess){
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }

        this.escolasOrigem = response.data;
        this.ativaEscolaOrigem();
        this.spinnerService.hide();
    }
  }

  public ativaEscolaOrigem(){
    if(this.escolasOrigem != undefined && this.userLogado?.codigoEscola != 0) {

      const escola = this.escolasOrigem.find(s=>s.codigoEscola == this.userLogado?.codigoEscola)

      if(this.userLogado?.codigoEscola != undefined  && escola != undefined)
        this.formDeslocamento.get('codigoEscolaOrigem')?.setValue(this.userLogado?.codigoEscola);
    }
  }

  public zerarEscolaOrigem() {
    this.escolasOrigem = [];
    this.formDeslocamento.get('codigoEscolaOrigem')?.patchValue(null);
  }

  //#endregion

  //#region Diretorias/Escolas Destino

  public async trocaDiretoriaDestino(){
    const codigoDiretoria = this.formDeslocamento.get('codigoDiretoriaDestino')?.value;

    if(codigoDiretoria && codigoDiretoria > 0)
      await this.getEscolasPorDiretoriaDestino();
    else{
      this.escolasDestino = [];
      this.form.codigoEscolaDestino.setValue(null);
    }

    this.ValidaAtividadeDiretoriaDestino();
    await this.removerRota();
  }

  public async getEscolasPorDiretoriaDestino(){
    const codigoDiretoria = this.formDeslocamento.get('codigoDiretoriaDestino')?.value;

    if(codigoDiretoria && codigoDiretoria > 0) {
      this.spinnerService.show();
      this.zerarEscolaDestino();

      const response = await lastValueFrom( this.escolaService.getEscolasPorCodigoDiretoria(codigoDiretoria))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

        if(!response.isSucess){
          this.toastr.error(response.message);
          this.spinnerService.hide();
          return;
        }

        this.escolasDestino = response.data;
        this.ativaEscolaDestino();
        this.spinnerService.hide();
    }
  }

  public ativaEscolaDestino(){
    const codigoEscola = this.formDeslocamento.get('codigoEscolaDestino')?.value;

    if(this.escolasDestino != undefined && codigoEscola > 0) {
      const escola = this.escolasDestino.find((s) => s.codigoEscola === codigoEscola);
      if (escola) {
        this.formDeslocamento.get('codigoEscolaDestino')?.setValue(codigoEscola);
      }
    }
  }

  public zerarEscolaDestino() {
    this.escolasDestino = [];
    this.formDeslocamento.get('codigoEscolaDestino')?.patchValue(null);
  }

  //#endregion

  //#region Salvar/Limpar

  public async onSalvar(){
    this.submitted = true;

    if (this.formDeslocamento.invalid) {
      return;
    }

    if(!this.gerouRota){
      this.toastr.warning('Por favor Gere o seu Deslocamento com o Mapa ...');
      return;
    }

    this.spinnerService.show();
    const dirOrigem = this.diretoriasOrigem.filter(r => r.codigoDiretoria == this.formDeslocamento.get('codigoDiretoriaOrigem')?.value)[0];
    const escOrigem = this.escolasOrigem.filter(r => r.codigoEscola == this.formDeslocamento.get('codigoEscolaOrigem')?.value)[0];
    const dirDestino = this.diretoriasDestino.filter(r => r.codigoDiretoria == this.formDeslocamento.get('codigoDiretoriaDestino')?.value)[0];
    const escDestino = this.escolasDestino.filter(r => r.codigoEscola == this.formDeslocamento.get('codigoEscolaDestino')?.value)[0];

    this.toastr.success('Deslocamento feito com sucesso ...');
    this.spinnerService.hide();

    // Origem
    this.model.codigoPoloOrigem = this.form.codigoPoloOrigem.value;
    this.model.codigoDiretoriaOrigem = dirOrigem.codigoDiretoria;
    this.model.nomeDiretoriaOrigem = dirOrigem.nomeDiretoria;
    this.model.codigoEscolaOrigem    = escOrigem?.codigoEscola ?? 0;
    this.model.nomeEscolaOrigem      = escOrigem?.nomeEscola   ?? '';

    // Destino
    this.model.codigoPoloDestino = this.form.codigoPoloDestino.value;
    this.model.codigoDiretoriaDestino = dirDestino.codigoDiretoria;
    this.model.nomeDiretoriaDestino = dirDestino.nomeDiretoria;
    this.model.codigoEscolaDestino    = escDestino?.codigoEscola ?? 0;
    this.model.nomeEscolaDestino      = escDestino?.nomeEscola   ?? '';

    // Deslocamento
    this.model.codigoTipoTransporte = this.formDeslocamento.get('codigoTipoTransporte')?.value;
    this.model.horarioSaida = this.formDeslocamento.get('horarioSaida')?.value;
    this.model.horarioChegada = this.formDeslocamento.get('horarioChegada')?.value;
    this.model.tempoDeslocamento = this.formDeslocamento.get('tempoDeslocamento')?.value;
    this.model.kmPercorrido = this.formDeslocamento.get('kmPercorrido')?.value;

    this.proximoPasso.emit(this.model);
  }

  public async onLimpar() {
    this.spinnerService.show();

    this.formDeslocamento.get('codigoPoloOrigem')?.patchValue(null);
    this.formDeslocamento.get('codigoDiretoriaOrigem')?.patchValue(null);
    this.formDeslocamento.get('codigoEscolaOrigem')?.patchValue(null);

    this.formDeslocamento.get('codigoPoloDestino')?.patchValue(null);
    this.formDeslocamento.get('codigoDiretoriaDestino')?.patchValue(null);
    this.formDeslocamento.get('codigoEscolaDestino')?.patchValue(null);

    this.formDeslocamento.get('codigoTipoTransporte')?.patchValue(null);
    this.formDeslocamento.get('horarioSaida')?.patchValue(null);
    this.formDeslocamento.get('horarioChegada')?.patchValue(null);
    this.formDeslocamento.get('tempoDeslocamento')?.patchValue(null);
    this.formDeslocamento.get('kmPercorrido')?.patchValue(null);

    this.spinnerService.hide();
  }

  //#endregion

  //#region Mapa

  public async gerarRota(){
    this.submitted = true;

    if (this.formDeslocamento.invalid) {
      return;
    }

    await this.loadMap();
  }

  public async loadMap() {

    const code = (this.atividadeDiretoriaOrigem ? 2 : 0) + (this.atividadeDiretoriaDestino ? 1 : 0);

    // Preenche as coordenadas de origem e destino conforme o deslocamento
    switch (code) {
      case 3: // Deslocamento entre duas diretorias
        await this.detalhesDiretoriaOrigemDestino();
        this.latOrigem = +this.diretoriaOrigem.latitude;
        this.lngOrigem = +this.diretoriaOrigem.longitude;
        this.latDestino = +this.diretoriaDestino.latitude;
        this.lngDestino = +this.diretoriaDestino.longitude;

        this.titleOrigem = `<b>Origem</b> <br/> <b>Diretoria</b>: ${this.diretoriaOrigem.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaOrigem.codigoDiretoria}`;
        this.titleOrigemMark = `Origem - Diretoria: ${this.diretoriaOrigem.nomeDiretoria} - CIE: ${this.diretoriaOrigem.codigoDiretoria}`;
        this.titleDestino = `<b>Destino</b> <br/> <b>Diretoria</b>: ${this.diretoriaDestino.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaDestino.codigoDiretoria}`;
        this.titleDestinoMark = `Destino - Diretoria: ${this.diretoriaDestino.nomeDiretoria} - CIE: ${this.diretoriaDestino.codigoDiretoria}`;
        break;

      case 2: // Deslocamento entre D.E e E.E
        await this.detalhesDiretoriaOrigemEscolaDestino();
        this.latOrigem = +this.diretoriaOrigem.latitude;
        this.lngOrigem = +this.diretoriaOrigem.longitude;
        this.latDestino = +this.escolaDestino.latitude;
        this.lngDestino = +this.escolaDestino.longitude;

        this.titleOrigem = `<b>Origem</b> <br/> <b>Diretoria</b>: ${this.diretoriaOrigem.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaOrigem.codigoDiretoria}`;
        this.titleOrigemMark = `Origem - Diretoria: ${this.diretoriaOrigem.nomeDiretoria} - CIE: ${this.diretoriaOrigem.codigoDiretoria}`;
        this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
        this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
        break;

      case 1: // Deslocamento entre E.E e D.E
        await this.detalhesEscolaOrigemDiretoriaDestino();
        this.latOrigem = +this.escolaOrigem.latitude;
        this.lngOrigem = +this.escolaOrigem.longitude;
        this.latDestino = +this.diretoriaDestino.latitude;
        this.lngDestino = +this.diretoriaDestino.longitude;

        this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
        this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
        this.titleDestino = `<b>Destino</b> <br/> <b>Diretoria</b>: ${this.diretoriaDestino.nomeDiretoria} <br/> <b>CIE</b>: ${this.diretoriaDestino.codigoDiretoria}`;
        this.titleDestinoMark = `Destino - Diretoria: ${this.diretoriaDestino.nomeDiretoria} - CIE: ${this.diretoriaDestino.codigoDiretoria}`;
        break;

      case 0: // Deslocamento entre duas escolas
        await this.detalhesEscolaOrigemDestino();
        this.latOrigem = +this.escolaOrigem.latitude;
        this.lngOrigem = +this.escolaOrigem.longitude;
        this.latDestino = +this.escolaDestino.latitude;
        this.lngDestino = +this.escolaDestino.longitude;

        this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
        this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
        this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
        this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
        break;

      default: // Deslocamento entre duas escolas
        await this.detalhesEscolaOrigemDestino();
        this.latOrigem = +this.escolaOrigem.latitude;
        this.lngOrigem = +this.escolaOrigem.longitude;
        this.latDestino = +this.escolaDestino.latitude;
        this.lngDestino = +this.escolaDestino.longitude;

        this.titleOrigem = `<b>Origem</b> <br/> <b>Escola</b>: ${this.escolaOrigem.nomeEscola} <br/> <b>CIE</b>: ${this.escolaOrigem.codigoEscola}`;
        this.titleOrigemMark = `Origem - Escola: ${this.escolaOrigem.nomeEscola} - CIE: ${this.escolaOrigem.codigoEscola}`;
        this.titleDestino = `<b>Destino</b> <br/> <b>Escola</b>: ${this.escolaDestino.nomeEscola} <br/> <b>CIE</b>: ${this.escolaDestino.codigoEscola}`;
        this.titleDestinoMark = `Destino - Escola: ${this.escolaDestino.nomeEscola} - CIE: ${this.escolaDestino.codigoEscola}`;
        break;
    }

    if (this.escolasOrigemDestinoIguais()) {
      this.gerouRota = false;
      this.toastr.warning('A escola de destino deve ser diferente da escola de origem.');
      return;
    }

    if (this.podeGerarRotaMapa()) {
      if(await this.validarLatLong()) {

        this.spinnerService.show();

        const mapOptions = {
          center: { lat: -23.5489, lng: -46.6388 }, // Lat/Long Central SP
          zoom: 9, // Zoom SP
          mapId: "MapaDeslocamento",
        };

        const divMaps = document.getElementById("map");

        if(divMaps){
          divMaps.style.display = 'unset'

          // Bibliotecas google
          const importMaps = await this.mapsService.loader.importLibrary('maps');
          const importMapsRoutes = await this.mapsService.loader.importLibrary('routes');
          const importMapsMarkers = await this.mapsService.loader.importLibrary('marker');

          // Serviços google
          const serviceDisplay = new importMapsRoutes.DirectionsRenderer({suppressMarkers: true});
          const serviceRoute = new importMapsRoutes.DirectionsService();
          const infoWindow = new importMaps.InfoWindow();

          const maps = new importMaps.Map(divMaps, mapOptions)
          serviceDisplay.setMap(maps);

          // Marcador de Origem
          const pinOrigem = new importMapsMarkers.PinElement({background: '#FBBC04'});
          const markerOrigem = new importMapsMarkers.AdvancedMarkerElement({
            gmpDraggable: false,
            map: maps,
            position: this.getLatLong(+this.latOrigem, +this.lngOrigem),
            title: this.titleOrigemMark,
            content: pinOrigem.element
          });
          markerOrigem.addListener('click', () => {
              infoWindow.setContent(this.titleOrigem);
              infoWindow.setPosition(markerOrigem.position);
              infoWindow.open(maps, markerOrigem);
          });

          // Marcador de Destino
          const pinDestino= new importMapsMarkers.PinElement({background: '#00FF7F'});
          const markerDestino = new importMapsMarkers.AdvancedMarkerElement({
            gmpDraggable: false,
            map: maps,
            position: this.getLatLong(+this.latDestino, +this.lngDestino),
            title: this.titleDestinoMark,
            content: pinDestino.element
          });
          markerDestino.addListener('click', () => {
            infoWindow.setContent(this.titleDestino);
            infoWindow.setPosition(markerDestino.position);
            infoWindow.open(maps, markerDestino);
          });

          this.requestRoute.origin = this.getLatLong(+this.latOrigem, +this.lngOrigem);
          this.requestRoute.destination = this.getLatLong(+this.latDestino, +this.lngDestino);
          const tipoTransporte = this.formDeslocamento.get('codigoTipoTransporte')?.value;

          switch (tipoTransporte) {
            case 1: {
              this.requestRoute.travelMode = google.maps.TravelMode.BICYCLING;
              break;
            }
            case 2: {
              this.requestRoute.travelMode = google.maps.TravelMode.DRIVING;
              break;
            }
            case 3: {
              this.requestRoute.travelMode = google.maps.TravelMode.TRANSIT;
              break;
            }
            case 4: {
              this.requestRoute.travelMode = google.maps.TravelMode.WALKING;
              break;
            }
            case 5: {
              this.requestRoute.travelMode = 'TWO_WHEELER' as google.maps.TravelMode;
              break;
            }
          }

          // Executando Serviço de Rotas do Google.
          await serviceRoute.route(this.requestRoute, (result, status) => {
            if(status == google.maps.DirectionsStatus.ZERO_RESULTS){
              this.gerouRota = false;
              this.toastr.warning('Houve algum problema ao Gerar a Rota ...');
              this.spinnerService.hide();
            }
            else if (status === google.maps.DirectionsStatus.OK) {
                serviceDisplay.setDirections(result);
                this.gerouRota = true;
                if(result)
                  this.resultRoute = result;
            }

          });

          if(this.gerouRota)
            await this.computeTotalDistance(this.resultRoute);
        }

        this.spinnerService.hide();
      }
      else {
        this.gerouRota = false;
        this.toastr.warning('Houve algum problema ao buscar os Detalhes das Lat/Long ...');
        this.toastr.warning(this.msgLatLongInvalida);
      }
    }
    else {
      this.gerouRota = false;
      this.toastr.warning(
        'Não foi possível gerar a rota. Verifique se os pontos de origem e destino possuem localizações distintas.',
      );
    }
  }

  /** Mesma URE é permitida; origem e destino não podem ser a mesma escola. */
  private escolasOrigemDestinoIguais(): boolean {
    if (this.atividadeDiretoriaOrigem || this.atividadeDiretoriaDestino) {
      return false;
    }

    const codEscolaOrigem = this.formDeslocamento.get('codigoEscolaOrigem')?.value;
    const codEscolaDestino = this.formDeslocamento.get('codigoEscolaDestino')?.value;

    return (
      codEscolaOrigem != null &&
      codEscolaDestino != null &&
      codEscolaOrigem > 0 &&
      codEscolaDestino > 0 &&
      codEscolaOrigem === codEscolaDestino
    );
  }

  private podeGerarRotaMapa(): boolean {
    if (this.atividadeDiretoriaOrigem && this.atividadeDiretoriaDestino) {
      return true;
    }

    return this.latOrigem !== this.latDestino || this.lngOrigem !== this.lngDestino;
  }

  public async detalhesEscolaOrigemDestino(){
    const escolaOrigem = this.formDeslocamento.get('codigoEscolaOrigem')?.value;
    const escolaDestino = this.formDeslocamento.get('codigoEscolaDestino')?.value;

    this.spinnerService.show();

    const resultEscolaOrigem = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaOrigem))
                              .catch((err) => {
                                return this.ConvivaErrors.handleResultError(err);
                              });

    if(!resultEscolaOrigem.isSucess){
        this.toastr.error(resultEscolaOrigem.message);
        this.spinnerService.hide();
        return;
    }

    this.escolaOrigem = resultEscolaOrigem.data;
    const resultEscolaDestino = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaDestino))
                                .catch((err) => {
                                  return this.ConvivaErrors.handleResultError(err);
                                });

    if(!resultEscolaDestino.isSucess){
        this.toastr.error(resultEscolaDestino.message);
        this.spinnerService.hide();
        return;
    }
    this.escolaDestino = resultEscolaDestino.data;
    this.spinnerService.hide();
  }

  public async detalhesDiretoriaOrigemDestino(){
    const diretoriaOrigem = this.formDeslocamento.get('codigoDiretoriaOrigem')?.value;
    const diretoriaDestino = this.formDeslocamento.get('codigoDiretoriaDestino')?.value;

    this.spinnerService.show();

    const resultDiretoriaOrigem = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaOrigem))
                                      .catch((err) => {
                                        return this.ConvivaErrors.handleResultError(err);
                                      });

    if(!resultDiretoriaOrigem.isSucess){
        this.toastr.error(resultDiretoriaOrigem.message);
        this.spinnerService.hide();
        return;
    }

    this.diretoriaOrigem = resultDiretoriaOrigem.data[0];

    const resultDiretoriaDestino = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaDestino))
                                      .catch((err) => {
                                        return this.ConvivaErrors.handleResultError(err);
                                      });

    if(!resultDiretoriaDestino.isSucess) {
        this.toastr.error(resultDiretoriaDestino.message);
        this.spinnerService.hide();
        return;
    }

    this.diretoriaDestino = resultDiretoriaDestino.data[0];
    this.spinnerService.hide();
  }

  public async detalhesDiretoriaOrigemEscolaDestino(){
    const diretoriaOrigem = this.formDeslocamento.get('codigoDiretoriaOrigem')?.value;
    const escolaDestino = this.formDeslocamento.get('codigoEscolaDestino')?.value;

    this.spinnerService.show();

    const resultDiretoriaOrigem = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaOrigem))
                              .catch((err) => {
                                return this.ConvivaErrors.handleResultError(err);
                              });

    if(!resultDiretoriaOrigem.isSucess) {
        this.toastr.error(resultDiretoriaOrigem.message);
        this.spinnerService.hide();
        return;
    }

    this.diretoriaOrigem = resultDiretoriaOrigem.data[0];

    const resultEscolaDestino = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaDestino))
                                .catch((err) => {
                                  return this.ConvivaErrors.handleResultError(err);
                                });

    if(!resultEscolaDestino.isSucess){
        this.toastr.error(resultEscolaDestino.message);
        this.spinnerService.hide();
        return;
    }
    this.escolaDestino = resultEscolaDestino.data;
    this.spinnerService.hide();
  }

  public async detalhesEscolaOrigemDiretoriaDestino(){
    const escolaOrigem = this.formDeslocamento.get('codigoEscolaOrigem')?.value;
    const diretoriaDestino = this.formDeslocamento.get('codigoDiretoriaDestino')?.value;

    this.spinnerService.show();

    const resultEscolaOrigem = await lastValueFrom(this.escolaService.getEscolaDetalhes(escolaOrigem))
                              .catch((err) => {
                                return this.ConvivaErrors.handleResultError(err);
                              });

    if(!resultEscolaOrigem.isSucess){
        this.toastr.error(resultEscolaOrigem.message);
        this.spinnerService.hide();
        return;
    }

    this.escolaOrigem = resultEscolaOrigem.data;

    const resultDiretoriaDestino = await lastValueFrom(this.escolaService.getDiretoriaPorCodigo(diretoriaDestino))
                                      .catch((err) => {
                                        return this.ConvivaErrors.handleResultError(err);
                                      });

    if(!resultDiretoriaDestino.isSucess){
        this.toastr.error(resultDiretoriaDestino.message);
        this.spinnerService.hide();
        return;
    }
    this.diretoriaDestino = resultDiretoriaDestino.data[0];
    this.spinnerService.hide();
  }

  public async validarLatLong(): Promise<boolean> {
    this.msgLatLongInvalida = '';

    if(+this.latOrigem != 0 && +this.lngOrigem != 0 && +this.latDestino != 0 && +this.lngDestino != 0){
      return true;
    }

    if(+this.latOrigem == 0 || +this.lngOrigem == 0){
      this.msgLatLongInvalida = `A Origem está com problema na Lat/Long ... `;
    }

    if(+this.latDestino == 0 || +this.lngDestino == 0){
      this.msgLatLongInvalida += `O Destino está com problema na Lat/Long ...`;
    }

    return false;
  }

  public getLatLong(lat: number, lng: number): google.maps.LatLng{
    return new google.maps.LatLng({lat, lng});
  }

  public async computeTotalDistance(result: google.maps.DirectionsResult) {
    const myroute = result.routes[0];

    if (!myroute) {
        return;
    }

    this.totalKm = 0;
    this.totalSeg = 0;
    myroute.legs.forEach((element) => {
      if(element.distance && element.duration){
        this.totalKm += element.distance.value;
        this.totalSeg += element.duration.value;
      }
    });

    const hours = Math.floor(this.totalSeg / 3600) < 10 ? (`00${  Math.floor(this.totalSeg / 3600)}`).slice(-2) : Math.floor(this.totalSeg / 3600);
    const minutes = (`00${  Math.floor((this.totalSeg % 3600) / 60)}`).slice(-2);
    this.totalDuration = `${hours  }:${  minutes  }`;
    this.totalKm = parseInt((this.totalKm / 1000).toString());

    this.form.tempoDeslocamento.setValue(this.totalDuration);
    this.form.kmPercorrido.setValue(this.totalKm);

    const response = await lastValueFrom(this.utilsService.calcularHoras(this.form.horarioSaida.value, this.totalDuration))
                        .catch((err) => {
                          return this.ConvivaErrors.handleResultError(err);
                        });

    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }

    this.form.horarioChegada.setValue(response.data);
  }

  public async trocaHoraSaida(){
    const horaSaida = this.form.horarioSaida.value;

    if(this.gerouRota){
      const response = await lastValueFrom(this.utilsService.calcularHoras(horaSaida, this.totalDuration))
                          .catch((err) => {
                            return this.ConvivaErrors.handleResultError(err);
                          });

      if(!response.isSucess){
        this.toastr.error(response.message);
        this.spinnerService.hide();
        return;
      }

      this.form.horarioChegada.setValue(response.data);
    }
  }

  public async removerRota() {
    this.gerouRota = false;

    this.form.horarioChegada.setValue(null);
    this.form.tempoDeslocamento.setValue(null);
    this.form.kmPercorrido.setValue(null);

    const divMaps = document.getElementById("map");
    if(divMaps) {
      divMaps.innerHTML = ''; // Limpa a div do maps.
      divMaps.style.display = 'none'
    }
  }

  //#endregion

  public ValidaAtividadeDiretoriaOrigem() {
    if(this.atividadeDiretoriaOrigem){
      this.form.codigoEscolaOrigem.clearValidators();
      this.form.codigoEscolaOrigem.setValue(null);
      this.form.codigoEscolaOrigem.disable();
    }else{
      this.form.codigoEscolaOrigem.setValidators([Validators.required]);
        this.form.codigoEscolaOrigem.setValue(this.userLogado?.codigoEscola ?? null);
      this.form.codigoEscolaOrigem.enable();
    }

    this.form.codigoEscolaOrigem.updateValueAndValidity();
  }

  public OnChangeApenasDiretoriaOrigem(){
    this.atividadeDiretoriaOrigem = !this.atividadeDiretoriaOrigem;
    this.ValidaAtividadeDiretoriaOrigem();
  }

  public ValidaAtividadeDiretoriaDestino() {
    if(this.atividadeDiretoriaDestino){
      this.form.codigoEscolaDestino.clearValidators();
      this.form.codigoEscolaDestino.setValue(null);
      this.form.codigoEscolaDestino.disable();
    }else{
      this.form.codigoEscolaDestino.setValidators([Validators.required]);
      this.form.codigoEscolaDestino.setValue(null);
      this.form.codigoEscolaDestino.enable();
    }

    this.form.codigoEscolaDestino.updateValueAndValidity();
  }

  public OnChangeApenasDiretoriaDestino(){
    this.atividadeDiretoriaDestino = !this.atividadeDiretoriaDestino;
    this.ValidaAtividadeDiretoriaDestino();
  }
}

